'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useEffect } from 'react';
import { connect } from 'react-redux';
import TabLayout from 'pricing-pages-unified-ui/components/tabs/TabLayout';
import { NavMarker } from 'react-rhumb';
import PageContainer from 'pricing-pages-unified-ui/components/common/PageContainer';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-unified-ui/selectors/LoadingStateSelectors';
import StyledBlob from 'pricing-pages-unified-ui/components/common/StyledBlob';
import FailedLoadBanner from 'pricing-pages-unified-ui/components/loading/FailedLoadBanner';
import BannerSection from 'pricing-pages-unified-ui/components/banners/BannerSection';
import CustomerSupport from 'pricing-pages-unified-ui/components/common/CustomerSupport';
import HubSpotPayments from 'pricing-pages-unified-ui/components/common/HubSpotPayments';
import Faq from 'pricing-pages-unified-ui/components/common/Faq';
import FooterMicrocopy from 'pricing-pages-unified-ui/components/common/FooterMicrocopy';
import PhoneSupportFooter from 'pricing-pages-unified-ui/components/common/PhoneSupportFooter';
import { SCREENS, SUBSCREENS } from 'pricing-pages-unified-ui/constants/Tracking';
import HubInfoContainer from 'pricing-pages-unified-ui/components/common/HubInfoContainer';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { withDocumentTitle } from 'pricing-pages-unified-ui/utils/DocumentUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HubSubtitle from 'pricing-pages-unified-ui/components/common/HubSubtitle';
import StandardProductPageTitle from 'pricing-pages-unified-ui/components/product-pages/StandardProductPageTitle';
import HubTierInfo from 'pricing-pages-unified-ui/components/product-pages/HubTierInfo';
import MigrateYourSite from 'pricing-pages-unified-ui/components/cms-hub-page/MigrateYourSite';
import PhoneSupport from 'pricing-pages-unified-ui/components/common/PhoneSupport';
import PhoneSupportWrapper from 'pricing-pages-unified-ui/components/common/phone-numbers/PhoneSupportWrapper';
import Question from 'pricing-pages-unified-ui/components/common/Question';
import styled from 'styled-components';
import breakpoints from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import CurrencyPicker from 'pricing-pages-unified-ui/components/common/CurrencyPicker';
import { useQueryParamTerm } from '../../utils/stateUtils';
import { useQueryParamsEffect } from '../../utils/queryParamUtils';
import { TabEnum } from '../../constants/TabConfig';
import { CMS } from 'self-service-api/constants/ProductLines';
import { getCMSUrlPublic, getLanguagesUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getAcademyUrlPublic, getCMSOnboardingUrlPublic, getProductAndServicesUrlPublic, getStartupsUrlPublic, getNonprofitsUrlPublic, PAYMENTS_LANDING_PAGE_URL } from 'pricing-pages-lib/utils/publicPageUrls';
import { HubCalculator } from '../common/Calculator';
import { useTrackRetail } from '../../selectors/RetailSelectors';
import RecommendedBundlesSection from '../product-pages/bundles-section/RecommendedBundlesSection';
import CalculatorAnchorLink from '../common/CalculatorAnchorLink';
import FallbackErrorBanner from '../loading/FallbackErrorBanner';
import { getHighlightsForProductLine } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { useFeatureStore } from '../../hooks/useFeatureStore';
import CodeSplitEnvWrapper from '../CodeSplitEnvWrapper';
const MigrateYourSiteWrapper = styled.div.withConfig({
  displayName: "CmsHubPage__MigrateYourSiteWrapper",
  componentId: "sc-1jfgdzr-0"
})(["margin-top:64px;margin-bottom:0;", ""], breakpoints.sd(_t || (_t = _`
    margin-top: 96px;
    margin-bottom: 96px;
  `)));

const CmsHubPage = ({
  hasPricingAndPurchasingSucceeded,
  hasPricingAndPurchasingFailed
}) => {
  useTrackRetail();
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.PRODUCTS_PLANS,
      subscreen: SUBSCREENS.CMS_HUB
    });
  }, []);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  const highlightedProducts = getHighlightsForProductLine(CMS);
  useFeatureStore({
    highlightedProducts,
    productLine: CMS
  });
  return /*#__PURE__*/_jsx(TabLayout, {
    selectedPrimaryTab: TabEnum.PRODUCTS,
    selectedSecondaryTab: TabEnum.CMS,
    children: /*#__PURE__*/_jsxs(PageContainer, {
      "data-selenium-id": "page-success",
      children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
        name: "CMS_PAGE"
      }), /*#__PURE__*/_jsx(CurrencyPicker, {}), /*#__PURE__*/_jsx(StyledBlob, {}), /*#__PURE__*/_jsxs(HubInfoContainer, {
        children: [/*#__PURE__*/_jsx(FailedLoadBanner, {
          hasFailed: hasPricingAndPurchasingFailed
        }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsx(StandardProductPageTitle, {
          productLine: CMS,
          includeRegisteredTrademark: true
        }), /*#__PURE__*/_jsxs(HubSubtitle, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages.hubs.cmsHub.description"
          }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {})]
        }), /*#__PURE__*/_jsx(BannerSection, {
          productLine: CMS,
          screen: SCREENS.PRODUCTS_PLANS,
          subscreen: SUBSCREENS.CMS_HUB
        }), /*#__PURE__*/_jsx(HubTierInfo, {
          productLine: CMS
        }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          publicComponentLoader: () => import(
          /* webpackChunkName: "public-chunk" */
          'pricing-pages-unified-ui/components/common/FreeCard'),
          publicComponentProps: {
            productLine: CMS
          }
        }), /*#__PURE__*/_jsx(RecommendedBundlesSection, {
          productLine: CMS
        }), /*#__PURE__*/_jsx(PhoneSupportWrapper, {
          children: /*#__PURE__*/_jsx(PhoneSupport, {
            phoneSourceId: "cms-middle",
            screen: SUBSCREENS.CMS_HUB
          })
        }), /*#__PURE__*/_jsx(HubSpotPayments, {}), /*#__PURE__*/_jsx(HubCalculator, {
          productLine: CMS,
          screen: SUBSCREENS.CMS_HUB
        }), /*#__PURE__*/_jsx(MigrateYourSiteWrapper, {
          children: /*#__PURE__*/_jsx(MigrateYourSite, {})
        }), /*#__PURE__*/_jsx(CustomerSupport, {
          className: "m-top-10"
        }), /*#__PURE__*/_jsxs(Faq, {
          children: [/*#__PURE__*/_jsx(Question, {
            questionKey: "cmsHub.whatIsCMSHub411",
            href: getCMSUrlPublic()
          }), /*#__PURE__*/_jsx(Question, {
            questionKey: "sales.whatIsPayments411",
            href: PAYMENTS_LANDING_PAGE_URL
          }), /*#__PURE__*/_jsx(Question, {
            questionKey: "cmsHub.whatSupport411",
            passedInOptions: {
              communityHref: getCommunityUrlPublic(),
              academyHref: getAcademyUrlPublic(),
              kbHref: getKnowledgeBaseUrlPublic(),
              onboardingHref: getCMSOnboardingUrlPublic(),
              langHref: getLanguagesUrlPublic(),
              onLinkClick: url => {
                getUsageTracker().track('externalLinkClick', {
                  name: 'faq-click-link',
                  url
                });
              }
            }
          }), /*#__PURE__*/_jsx(Question, {
            questionKey: "cmsHub.whatLimits411",
            href: getProductAndServicesUrlPublic()
          }), /*#__PURE__*/_jsx(Question, {
            questionKey: "cmsHub.whatDiscounts411",
            passedInOptions: {
              startupsHref: getStartupsUrlPublic('pricing-cmspage'),
              nonprofitsHref: getNonprofitsUrlPublic('pricing-cmspage'),
              onLinkClick: url => {
                getUsageTracker().track('externalLinkClick', {
                  name: 'faq-click-link',
                  url
                });
              }
            }
          }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
        }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
          phoneSourceId: "cms-footer",
          screen: SUBSCREENS.CMS_HUB
        })]
      })]
    })
  });
};

const mapStateToProps = state => ({
  hasPricingAndPurchasingSucceeded: hasPricingAndPurchasingSucceededSelector(state),
  hasPricingAndPurchasingFailed: hasPricingAndPurchasingFailedSelector(state)
});

export default connect(mapStateToProps)(withDocumentTitle(CmsHubPage, 'cms'));